module.exports = __webpack_public_path__ + "img/icon-balance.7aea0498.svg";